import { config } from "../core/config";
import type { Api } from "../domain/types";
let loading: Promise<Api> | undefined;
export function getApi(): Promise<Api> {
  return (loading ??= config.mock
    ? import("./mock").then((m) => m.mockApi)
    : import("./real").then((m) => m.realApi));
}
